module.exports = __webpack_public_path__ + "static/home-3-m-243de675cb70f077b7282cbe2f7e735b.mp4";